import React from 'react';
import { Form, Typography } from 'antd';
const { Paragraph } = Typography;
export default React.forwardRef((props, ref) => {
  const { editable, control, label, value } = props;

  return (
    <div>
      {
        editable && (control)
      }
      {
        !editable && (
          < Form.Item label={label}>
            {value}
          </Form.Item >
        )
      }
    </div>
  );
});
